import styles from "./Confirmation.module.css";

function InfoRow({ label, value }) {
  if (!value && value !== 0) return null;
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
}

function Section({ icon, title, color = "#f97316", children }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <div className={styles.iconBox} style={{ background: `${color}14`, border: `1px solid ${color}28` }}>
          <i className={`fa-solid ${icon}`} style={{ color, fontSize: "0.85rem" }} />
        </div>
        <span className={styles.sectionTitle}>{title}</span>
      </div>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  );
}

function CountBadge({ count, label, icon, color }) {
  return (
    <div className={styles.badge}>
      <i className={`fa-solid ${icon}`} style={{ color, fontSize: "0.78rem" }} />
      <span className={styles.badgeCount} style={{ color }}>{count}</span>
      <span className={styles.badgeLabel}>{label}</span>
    </div>
  );
}

export default function Confirmation({ formData }) {
  return (
    <div className="step">

      {/* ── Header ── */}
      <div className={`${styles.header} mt-2`}>
        <div className={styles.headerIcon}>
          <i className="fa-solid fa-clipboard-check" style={{ color: "#f97316" }} />
        </div>
        <div>
          <h3 className={styles.title}>Confirmación y Resumen</h3>
          <p className={styles.subtitle}>Verificá que los datos sean correctos antes de guardar</p>
        </div>
      </div>

      {/* ── Card ── */}
      <div className={styles.card}>

        {/* Card header */}
        <div className={styles.cardHeader}>
          <i className="fa-solid fa-list-check" style={{ color: "#f97316" }} />
          <span>Resumen de la información</span>
        </div>

        <div className={styles.grid}>

          {/* Filial */}
          <Section icon="fa-house" title="Filial" color="#f97316">
            <InfoRow label="ID Filial"          value={formData.filial.idFilial} />
            <InfoRow label="N° Plano"           value={formData.filial.numPlano} />
            <InfoRow label="N° Folio"           value={formData.filial.numFolio} />
            <InfoRow label="Tipo de propiedad"  value={formData.filial.tipoPropiedad} />
          </Section>

          {/* Propietario */}
          <Section icon="fa-user" title="Propietario" color="#60a5fa">
            <InfoRow label="Nombre"
              value={`${formData.propietario.nombre} ${formData.propietario.apellidos}`} />
            <InfoRow label="Email principal"    value={formData.propietario.emailPrincipal} />
          </Section>

        </div>

        {/* Counts */}
        <div className={styles.counts}>
          <CountBadge count={formData.copropietarios.length}
            label="copropietario(s)" icon="fa-users" color="#a78bfa" />
          <span className={styles.countDivider} />
          <CountBadge count={formData.autorizados.length}
            label="autorizado(s)" icon="fa-id-card" color="#4ade80" />
        </div>

      </div>

      {/* Notice */}
      <div className={`${styles.notice} d-flex align-items-center`}>
        <i className="fa-solid fa-circle-info" style={{ color:"#60a5fa", flexShrink:0 }} />
        <span>Al confirmar se creará el residente y todos sus datos asociados.</span>
      </div>

    </div>
  );
}
